// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Creative Upload Page Styles */
/* Matching Sense platform aesthetic with orange-purple gradient accents */

.upload-page {
  min-height: 100vh;
  background: var(--bg-primary);
}

/* Header */
.upload-header {
  background: var(--bg-secondary);
  border-bottom: 1px solid var(--border-color);
  padding: 24px 48px;
  position: sticky;
  top: 0;
  z-index: 100;
  backdrop-filter: blur(12px);
}

.upload-header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1600px;
  margin: 0 auto;
}

.upload-header-text h1 {
  font-family: 'DM Sans', sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 4px;
  letter-spacing: -0.5px;
}

.upload-header-text p {
  color: var(--text-secondary);
  font-size: 14px;
}

.upload-header-actions {
  display: flex;
  gap: 12px;
}

.btn-secondary {
  padding: 12px 24px;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  background: var(--bg-secondary);
  color: var(--text-secondary);
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-secondary:hover {
  border-color: var(--text-tertiary);
  color: var(--text-primary);
}

.btn-primary {
  padding: 12px 24px;
  border: none;
  border-radius: 10px;
  background: var(--accent-gradient);
  color: white;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 16px rgba(255, 107, 74, 0.3);
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(255, 107, 74, 0.4);
}

.btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.btn-primary svg {
  width: 18px;
  height: 18px;
}

/* Content Layout */
.upload-content {
  display: grid;
  grid-template-columns: 1fr 400px;
  gap: 32px;
  padding: 32px 48px;
  max-width: 1600px;
  margin: 0 auto;
}

@media (max-width: 1200px) {
  .upload-content {
    grid-template-columns: 1fr;
  }
}

/* Left Panel */
.upload-left-panel {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Drop Zone */
.drop-zone {
  position: relative;
  background: var(--bg-secondary);
  border-radius: 20px;
  padding: 48px;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
}

.drop-zone.has-files {
  padding: 32px;
}

.drop-zone-border {
  position: absolute;
  inset: 0;
  border-radius: 20px;
  padding: 2px;
  background: linear-gradient(135deg,
    rgba(255, 107, 74, 0.3) 0%,
    rgba(233, 75, 108, 0.3) 50%,
    rgba(142, 58, 154, 0.3) 100%
  );
  -webkit-mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  mask-composite: exclude;
  pointer-events: none;
  transition: all 0.3s ease;
}

.drop-zone:hover .drop-zone-border,
.drop-zone.dragging .drop-zone-border {
  background: var(--accent-gradient);
}

.drop-zone.dragging {
  transform: scale(1.01);
}

.drop-zone.dragging::before {
  content: '';
  position: absolute;
  inset: 0;
  background: var(--accent-gradient);
  opacity: 0.05;
  border-radius: 20px;
}

.drop-zone-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  position: relative;
  z-index: 1;
}

.drop-zone-icon {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background: linear-gradient(135deg,
    rgba(255, 107, 74, 0.1) 0%,
    rgba(142, 58, 154, 0.1) 100%
  );
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.drop-zone:hover .drop-zone-icon,
.drop-zone.dragging .drop-zone-icon {
  transform: translateY(-4px);
  background: linear-gradient(135deg,
    rgba(255, 107, 74, 0.15) 0%,
    rgba(142, 58, 154, 0.15) 100%
  );
}

.drop-zone-icon svg {
  width: 32px;
  height: 32px;
  color: var(--accent-orange);
}

.drop-zone-text {
  text-align: center;
}

.drop-zone-title {
  display: block;
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 4px;
}

.drop-zone-subtitle {
  color: var(--text-secondary);
  font-size: 14px;
}

.drop-zone-link {
  color: var(--accent-orange);
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.drop-zone-formats {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
}

.drop-zone-formats span {
  padding: 4px 10px;
  background: var(--bg-tertiary);
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* File List */
.file-list {
  background: var(--bg-secondary);
  border-radius: 16px;
  padding: 20px;
  animation: slideUp 0.4s ease;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.file-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--border-color);
}

.file-list-header h3 {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-primary);
}

.btn-text-danger {
  background: none;
  border: none;
  color: var(--danger);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.btn-text-danger:hover {
  background: rgba(231, 76, 60, 0.1);
}

/* File Grid */
.file-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 12px;
}

.file-card {
  position: relative;
  background: var(--bg-tertiary);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  animation: fadeInScale 0.3s ease backwards;
}

@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.file-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

.file-card.selected {
  box-shadow: 0 0 0 2px var(--accent-orange), 0 8px 24px rgba(255, 107, 74, 0.2);
}

.file-card.has-errors {
  box-shadow: 0 0 0 2px var(--danger);
}

.file-card.has-errors:hover {
  box-shadow: 0 0 0 2px var(--danger), 0 8px 24px rgba(231, 76, 60, 0.2);
}

/* Badges container */
.file-card-badges {
  position: absolute;
  bottom: 8px;
  left: 8px;
  display: flex;
  gap: 4px;
  z-index: 2;
}

.file-badge {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.file-badge svg {
  width: 12px;
  height: 12px;
}

.file-badge.error {
  background: var(--danger);
  color: white;
  font-size: 12px;
  font-weight: 700;
}

.file-badge.warning {
  background: var(--warning);
  color: white;
}

.file-badge.link-missing {
  background: #ff8c42;
  color: white;
}

/* Error tooltip on hover */
.file-card-error-tooltip {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  background: #2d2d2d;
  color: white;
  padding: 10px 14px;
  border-radius: 10px;
  font-size: 12px;
  line-height: 1.4;
  white-space: nowrap;
  z-index: 100;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  pointer-events: none;
}

.file-card-error-tooltip::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-top-color: #2d2d2d;
}

.file-card:hover .file-card-error-tooltip {
  opacity: 1;
  visibility: visible;
}

.file-card-error-tooltip .error-item {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #ff8a80;
}

.file-card-error-tooltip .error-item + .error-item {
  margin-top: 6px;
}

.file-card-error-tooltip .error-item svg {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}

.file-card-error-tooltip .error-item span {
  color: rgba(255, 255, 255, 0.9);
}

.file-card-error-tooltip .error-item.warning svg {
  color: #ffb74d;
}

.file-card-preview {
  position: relative;
  aspect-ratio: 1;
  background: #ffffff;
  overflow: hidden;
  border-radius: 12px 12px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-card-preview img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
}

.file-card-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-card-placeholder svg {
  width: 32px;
  height: 32px;
  opacity: 0.4;
}

.file-card-placeholder.image {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  color: #1976d2;
}

.file-card-placeholder.video {
  background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);
  color: #d32f2f;
}

.file-card-placeholder.html5 {
  background: linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%);
  color: #7b1fa2;
}

.file-card-type {
  position: absolute;
  top: 8px;
  left: 8px;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.file-card-type svg {
  width: 14px;
  height: 14px;
  color: var(--text-secondary);
}

.file-card-remove {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  border: none;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.2s ease;
}

.file-card:hover .file-card-remove {
  opacity: 1;
}

.file-card-remove:hover {
  background: var(--danger);
}

.file-card-remove svg {
  width: 14px;
  height: 14px;
}

.file-card-info {
  padding: 10px;
}

.file-card-name {
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 2px;
}

.file-card-meta {
  font-size: 11px;
  color: var(--text-tertiary);
}

.file-card-meta-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 2px;
}

.file-card-size {
  font-size: 10px;
  color: var(--text-tertiary);
  white-space: nowrap;
}

.file-card-dimensions-input {
  display: flex;
  align-items: center;
  gap: 2px;
}

.file-card-dimensions-input span {
  color: var(--text-tertiary);
  font-size: 10px;
}

.file-card-dimensions-input .dim-input {
  width: 32px;
  padding: 2px 4px;
  border: 1px solid transparent;
  border-radius: 3px;
  font-size: 10px;
  text-align: center;
  background: transparent;
  -moz-appearance: textfield;
  color: var(--text-secondary);
}

.file-card-dimensions-input .dim-input.filled {
  color: var(--text-secondary);
}

.file-card-dimensions-input .dim-input:not(.filled) {
  border-color: var(--danger);
  color: var(--danger);
  background: rgba(231, 76, 60, 0.05);
}

.file-card-dimensions-input .dim-input::-webkit-outer-spin-button,
.file-card-dimensions-input .dim-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.file-card-dimensions-input .dim-input:focus {
  outline: none;
  border-color: var(--accent-orange);
  background: var(--bg-secondary);
  color: var(--text-primary);
}

.file-card-dimensions-input .dim-input::placeholder {
  color: var(--text-tertiary);
}


/* Right Panel */
.upload-right-panel {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Settings Card */
.settings-card {
  background: var(--bg-secondary);
  border-radius: 16px;
  padding: 24px;
  animation: slideInRight 0.4s ease;
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.settings-header {
  margin-bottom: 24px;
}

.settings-header h2 {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 4px;
}

.settings-header p {
  font-size: 13px;
  color: var(--text-secondary);
}

/* Mode Toggle */
.mode-toggle {
  display: flex;
  background: var(--bg-tertiary);
  border-radius: 10px;
  padding: 4px;
  position: relative;
  margin-bottom: 24px;
}

.mode-toggle-btn {
  flex: 1 1;
  padding: 10px 16px;
  border: none;
  background: transparent;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  position: relative;
  z-index: 1;
  transition: color 0.3s ease;
}

.mode-toggle-btn svg {
  width: 16px;
  height: 16px;
}

.mode-toggle-btn.active {
  color: var(--text-primary);
}

.mode-toggle-indicator {
  position: absolute;
  top: 4px;
  left: 4px;
  width: calc(50% - 4px);
  height: calc(100% - 8px);
  background: var(--bg-secondary);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.mode-toggle-indicator.individual {
  transform: translateX(100%);
}

/* Settings Form */
.settings-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
}

.form-group label svg {
  width: 16px;
  height: 16px;
  color: var(--text-tertiary);
}

.form-group input,
.form-group textarea {
  padding: 12px 14px;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  font-size: 14px;
  font-family: inherit;
  background: var(--bg-primary);
  color: var(--text-primary);
  transition: all 0.2s ease;
  resize: none;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--accent-orange);
  box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);
}

.form-group input::placeholder,
.form-group textarea::placeholder {
  color: var(--text-tertiary);
}

.settings-form .form-hint,
.form-group .form-hint {
  display: block;
  font-size: 11px;
  color: var(--text-tertiary);
  margin-top: -2px;
  padding: 0;
  background: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none;
}

/* Dimensions input row */
.dimensions-warning {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  background: rgba(243, 156, 18, 0.1);
  border-radius: 8px;
  color: var(--warning);
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 12px;
}

.dimensions-warning svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.form-group-row {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  margin-bottom: 16px;
}

.form-group-small {
  flex: 1 1;
}

.form-group-small input {
  text-align: center;
}

.dimension-separator {
  padding-bottom: 12px;
  color: var(--text-tertiary);
  font-size: 16px;
}

/* Apply Button */
.btn-apply {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg,
    rgba(255, 107, 74, 0.1) 0%,
    rgba(142, 58, 154, 0.1) 100%
  );
  color: var(--accent-orange);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-apply:hover {
  background: linear-gradient(135deg,
    rgba(255, 107, 74, 0.15) 0%,
    rgba(142, 58, 154, 0.15) 100%
  );
}

.btn-apply svg {
  width: 18px;
  height: 18px;
}

/* No Selection State */
.no-selection {
  text-align: center;
  padding: 40px 20px;
  color: var(--text-secondary);
}

.no-selection-icon {
  width: 48px;
  height: 48px;
  margin: 0 auto 16px;
  border-radius: 12px;
  background: var(--bg-tertiary);
  display: flex;
  align-items: center;
  justify-content: center;
}

.no-selection-icon svg {
  width: 24px;
  height: 24px;
  color: var(--text-tertiary);
}

.no-selection p {
  font-size: 14px;
}

/* Selected File Header */
.selected-file-header {
  display: flex;
  gap: 12px;
  padding: 12px;
  background: var(--bg-tertiary);
  border-radius: 10px;
  margin-bottom: 8px;
}

.selected-file-preview {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
}

.selected-file-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.file-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-placeholder svg {
  width: 20px;
  height: 20px;
  opacity: 0.5;
}

.file-placeholder.image {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  color: #1976d2;
}

.file-placeholder.video {
  background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);
  color: #d32f2f;
}

.file-placeholder.html5 {
  background: linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%);
  color: #7b1fa2;
}

.selected-file-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
}

.selected-file-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.selected-file-meta {
  font-size: 12px;
  color: var(--text-tertiary);
}

/* File Navigation */
.file-navigation {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 16px;
  border-top: 1px solid var(--border-color);
  margin-top: 8px;
}

.btn-nav {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border: none;
  background: transparent;
  color: var(--text-secondary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.btn-nav:hover:not(:disabled) {
  background: var(--bg-tertiary);
  color: var(--text-primary);
}

.btn-nav:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.btn-nav svg {
  width: 16px;
  height: 16px;
}

.file-counter {
  font-size: 13px;
  color: var(--text-tertiary);
  font-weight: 500;
}

/* Summary Card */
.summary-card {
  background: var(--bg-secondary);
  border-radius: 16px;
  padding: 20px;
  animation: slideInRight 0.4s ease 0.1s backwards;
}

.summary-card h3 {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 16px;
}

.summary-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 16px;
}

.summary-stat {
  text-align: center;
  padding: 12px;
  background: var(--bg-tertiary);
  border-radius: 10px;
}

.summary-stat .stat-value {
  display: block;
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 2px;
}

.summary-stat .stat-label {
  font-size: 11px;
  color: var(--text-tertiary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.summary-types {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.summary-type {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
}

.summary-type svg {
  width: 14px;
  height: 14px;
}

.summary-type.image {
  background: rgba(14, 165, 233, 0.1);
  color: #0369a1;
}

.summary-type.video {
  background: rgba(239, 68, 68, 0.1);
  color: #dc2626;
}

.summary-type.html5 {
  background: rgba(139, 92, 246, 0.1);
  color: #7c3aed;
}

/* ========================================
   UPLOAD PROGRESS STATES
   ======================================== */

/* Upload progress bar in header */
.upload-progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  background: var(--accent-gradient);
  transition: width 0.3s ease;
  border-radius: 0 2px 2px 0;
}

/* Upload button states */
.btn-primary.uploading {
  background: var(--bg-tertiary);
  color: var(--text-primary);
  box-shadow: none;
  pointer-events: none;
  min-width: 180px;
}

.btn-primary.uploading .upload-btn-progress {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background: var(--accent-gradient);
  opacity: 0.2;
  border-radius: 10px;
  transition: width 0.3s ease;
}

.btn-primary.uploading .upload-btn-text {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Cancel button during upload */
.btn-cancel {
  padding: 12px 20px;
  border: 1px solid var(--danger);
  border-radius: 10px;
  background: transparent;
  color: var(--danger);
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-cancel:hover {
  background: rgba(231, 76, 60, 0.1);
}

/* Spinner animation */
@keyframes spin {
  to { transform: rotate(360deg); }
}

.spinner {
  width: 18px;
  height: 18px;
  border: 2px solid transparent;
  border-top-color: currentColor;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

/* File card upload states */
.file-card.uploading {
  pointer-events: none;
}

.file-card.uploading .file-card-preview::before {
  content: '';
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.85);
  z-index: 5;
}

.file-card-upload-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 6;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease;
}

.file-card.uploading .file-card-upload-overlay {
  opacity: 1;
  visibility: visible;
}

/* Circular progress indicator */
.circular-progress {
  width: 48px;
  height: 48px;
  position: relative;
}

.circular-progress svg {
  transform: rotate(-90deg);
  width: 48px;
  height: 48px;
}

.circular-progress .progress-bg {
  fill: none;
  stroke: rgba(0, 0, 0, 0.1);
  stroke-width: 4;
}

.circular-progress .progress-fill {
  fill: none;
  stroke: url(#progress-gradient);
  stroke-width: 4;
  stroke-linecap: round;
  stroke-dasharray: 126;
  stroke-dashoffset: 126;
  transition: stroke-dashoffset 0.3s ease;
}

.circular-progress .progress-text {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  color: var(--text-primary);
}

/* Success state */
.file-card.upload-success {
  box-shadow: 0 0 0 2px var(--success);
}

.file-card.upload-success:hover {
  box-shadow: 0 0 0 2px var(--success), 0 8px 24px rgba(39, 174, 96, 0.2);
}

.file-badge.success {
  background: var(--success);
  color: white;
}

@keyframes checkmark-pop {
  0% { transform: scale(0); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
}

.file-badge.success svg {
  animation: checkmark-pop 0.3s ease;
}

/* Error state during upload */
.file-card.upload-error {
  box-shadow: 0 0 0 2px var(--danger);
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-4px); }
  75% { transform: translateX(4px); }
}

.file-card.upload-error {
  animation: shake 0.3s ease;
}

/* Upload complete summary */
.upload-complete-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: linear-gradient(135deg, rgba(39, 174, 96, 0.1) 0%, rgba(39, 174, 96, 0.05) 100%);
  border: 1px solid rgba(39, 174, 96, 0.2);
  border-radius: 12px;
  margin-bottom: 20px;
}

.upload-complete-banner.has-errors {
  background: linear-gradient(135deg, rgba(243, 156, 18, 0.1) 0%, rgba(243, 156, 18, 0.05) 100%);
  border-color: rgba(243, 156, 18, 0.2);
}

.upload-complete-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.upload-complete-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: var(--success);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-complete-icon svg {
  width: 20px;
  height: 20px;
}

.upload-complete-banner.has-errors .upload-complete-icon {
  background: var(--warning);
}

.upload-complete-text h4 {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 2px;
}

.upload-complete-text p {
  font-size: 13px;
  color: var(--text-secondary);
}

/* Responsive */
@media (max-width: 1200px) {
  .upload-content {
    padding: 24px;
  }

  .upload-right-panel {
    order: -1;
  }
}

@media (max-width: 768px) {
  .upload-header {
    padding: 16px 24px;
  }

  .upload-header-content {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }

  .upload-content {
    padding: 16px;
  }

  .drop-zone {
    padding: 32px 24px;
  }

  .file-grid {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  }
}

/* ===== Edit Creatives Page Styles ===== */

/* Edit mode drop zone - shows preview instead of drag-drop content */
.drop-zone.edit-mode {
  cursor: default;
  padding: 24px;
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.drop-zone.edit-mode:hover {
  transform: none;
}

/* Preview wrapper inside edit mode drop zone */
.edit-preview-wrapper {
  width: 100%;
  height: 100%;
  min-height: 280px;
  max-height: 480px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.edit-preview-wrapper .edit-preview-image {
  max-width: 100%;
  max-height: 480px;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

.edit-preview-wrapper .edit-preview-video {
  max-width: 100%;
  max-height: 480px;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 8px;
  background: #000;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

.edit-preview-wrapper .edit-preview-iframe {
  border: none;
  border-radius: 8px;
  background: white;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

/* Loading state */
.loading-state {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid var(--border-color);
  border-top-color: var(--accent-orange);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

/* File card meta row for edit page */
.file-card-dims {
  font-size: 11px;
  color: var(--text-tertiary);
}

.file-card-id {
  font-size: 10px;
  color: var(--text-tertiary);
  opacity: 0.7;
}

.file-card-meta-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

/* Responsive adjustments for edit page */
@media (max-width: 1200px) {
  .edit-preview-container {
    min-height: 250px;
    max-height: 400px;
  }

  .edit-thumbnails-grid {
    grid-template-columns: repeat(auto-fill, minmax(70px, 1fr));
  }
}

@media (max-width: 768px) {
  .edit-preview-container {
    min-height: 200px;
    padding: 16px;
  }

  .edit-preview-info {
    padding: 12px 16px;
  }

  .edit-thumbnails-grid {
    grid-template-columns: repeat(auto-fill, minmax(60px, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/creative-upload.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC,0EAA0E;;AAE1E;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,WAAW;AACX;EACE,+BAA+B;EAC/B,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ;;;;GAIC;EACD;;6BAE2B;EAE3B,uBAAuB;EACvB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB;;;GAGC;EACD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;;EAEE,2BAA2B;EAC3B;;;GAGC;AACH;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,cAAc;AACd;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA,cAAc;AACd;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,8EAA8E;AAChF;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,sEAAsE;AACxE;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,aAAa;EACb,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;;AAGA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,wBAAwB;EACxB,+BAA+B;EAC/B,kBAAkB;EAClB,yCAAyC;EACzC,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;;EAEE,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB;;;GAGC;EACD,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE;;;GAGC;AACH;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;;6CAE6C;;AAE7C,kCAAkC;AAClC;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,kCAAkC;EAClC,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;EACZ,kCAAkC;EAClC,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA,sBAAsB;AACtB;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAC9B,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA,4BAA4B;AAC5B;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,qCAAqC;EACrC,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,+BAA+B;EAC/B,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,oCAAoC;AACtC;;AAEA;EACE,uEAAuE;AACzE;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,KAAK,mBAAmB,EAAE;EAC1B,MAAM,qBAAqB,EAAE;EAC7B,OAAO,mBAAmB,EAAE;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA,8BAA8B;AAC9B;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;AACpC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4FAA4F;EAC5F,wCAAwC;EACxC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,8FAA8F;EAC9F,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,4DAA4D;EAC9D;AACF;;AAEA,2CAA2C;;AAE3C,qEAAqE;AACrE;EACE,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,sCAAsC;EACtC,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;;AAEA,yCAAyC;AACzC;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,2DAA2D;EAC7D;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,2DAA2D;EAC7D;AACF","sourcesContent":["/* Creative Upload Page Styles */\n/* Matching Sense platform aesthetic with orange-purple gradient accents */\n\n.upload-page {\n  min-height: 100vh;\n  background: var(--bg-primary);\n}\n\n/* Header */\n.upload-header {\n  background: var(--bg-secondary);\n  border-bottom: 1px solid var(--border-color);\n  padding: 24px 48px;\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  backdrop-filter: blur(12px);\n}\n\n.upload-header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 1600px;\n  margin: 0 auto;\n}\n\n.upload-header-text h1 {\n  font-family: 'DM Sans', sans-serif;\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 4px;\n  letter-spacing: -0.5px;\n}\n\n.upload-header-text p {\n  color: var(--text-secondary);\n  font-size: 14px;\n}\n\n.upload-header-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.btn-secondary {\n  padding: 12px 24px;\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  background: var(--bg-secondary);\n  color: var(--text-secondary);\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-secondary:hover {\n  border-color: var(--text-tertiary);\n  color: var(--text-primary);\n}\n\n.btn-primary {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 10px;\n  background: var(--accent-gradient);\n  color: white;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 16px rgba(255, 107, 74, 0.3);\n}\n\n.btn-primary:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 24px rgba(255, 107, 74, 0.4);\n}\n\n.btn-primary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.btn-primary svg {\n  width: 18px;\n  height: 18px;\n}\n\n/* Content Layout */\n.upload-content {\n  display: grid;\n  grid-template-columns: 1fr 400px;\n  gap: 32px;\n  padding: 32px 48px;\n  max-width: 1600px;\n  margin: 0 auto;\n}\n\n@media (max-width: 1200px) {\n  .upload-content {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Left Panel */\n.upload-left-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n/* Drop Zone */\n.drop-zone {\n  position: relative;\n  background: var(--bg-secondary);\n  border-radius: 20px;\n  padding: 48px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  overflow: hidden;\n}\n\n.drop-zone.has-files {\n  padding: 32px;\n}\n\n.drop-zone-border {\n  position: absolute;\n  inset: 0;\n  border-radius: 20px;\n  padding: 2px;\n  background: linear-gradient(135deg,\n    rgba(255, 107, 74, 0.3) 0%,\n    rgba(233, 75, 108, 0.3) 50%,\n    rgba(142, 58, 154, 0.3) 100%\n  );\n  -webkit-mask:\n    linear-gradient(#fff 0 0) content-box,\n    linear-gradient(#fff 0 0);\n  -webkit-mask-composite: xor;\n  mask-composite: exclude;\n  pointer-events: none;\n  transition: all 0.3s ease;\n}\n\n.drop-zone:hover .drop-zone-border,\n.drop-zone.dragging .drop-zone-border {\n  background: var(--accent-gradient);\n}\n\n.drop-zone.dragging {\n  transform: scale(1.01);\n}\n\n.drop-zone.dragging::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: var(--accent-gradient);\n  opacity: 0.05;\n  border-radius: 20px;\n}\n\n.drop-zone-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  position: relative;\n  z-index: 1;\n}\n\n.drop-zone-icon {\n  width: 64px;\n  height: 64px;\n  border-radius: 16px;\n  background: linear-gradient(135deg,\n    rgba(255, 107, 74, 0.1) 0%,\n    rgba(142, 58, 154, 0.1) 100%\n  );\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n}\n\n.drop-zone:hover .drop-zone-icon,\n.drop-zone.dragging .drop-zone-icon {\n  transform: translateY(-4px);\n  background: linear-gradient(135deg,\n    rgba(255, 107, 74, 0.15) 0%,\n    rgba(142, 58, 154, 0.15) 100%\n  );\n}\n\n.drop-zone-icon svg {\n  width: 32px;\n  height: 32px;\n  color: var(--accent-orange);\n}\n\n.drop-zone-text {\n  text-align: center;\n}\n\n.drop-zone-title {\n  display: block;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 4px;\n}\n\n.drop-zone-subtitle {\n  color: var(--text-secondary);\n  font-size: 14px;\n}\n\n.drop-zone-link {\n  color: var(--accent-orange);\n  font-weight: 600;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.drop-zone-formats {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.drop-zone-formats span {\n  padding: 4px 10px;\n  background: var(--bg-tertiary);\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* File List */\n.file-list {\n  background: var(--bg-secondary);\n  border-radius: 16px;\n  padding: 20px;\n  animation: slideUp 0.4s ease;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.file-list-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.file-list-header h3 {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.btn-text-danger {\n  background: none;\n  border: none;\n  color: var(--danger);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.btn-text-danger:hover {\n  background: rgba(231, 76, 60, 0.1);\n}\n\n/* File Grid */\n.file-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n  gap: 12px;\n}\n\n.file-card {\n  position: relative;\n  background: var(--bg-tertiary);\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  animation: fadeInScale 0.3s ease backwards;\n}\n\n@keyframes fadeInScale {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.file-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);\n}\n\n.file-card.selected {\n  box-shadow: 0 0 0 2px var(--accent-orange), 0 8px 24px rgba(255, 107, 74, 0.2);\n}\n\n.file-card.has-errors {\n  box-shadow: 0 0 0 2px var(--danger);\n}\n\n.file-card.has-errors:hover {\n  box-shadow: 0 0 0 2px var(--danger), 0 8px 24px rgba(231, 76, 60, 0.2);\n}\n\n/* Badges container */\n.file-card-badges {\n  position: absolute;\n  bottom: 8px;\n  left: 8px;\n  display: flex;\n  gap: 4px;\n  z-index: 2;\n}\n\n.file-badge {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n}\n\n.file-badge svg {\n  width: 12px;\n  height: 12px;\n}\n\n.file-badge.error {\n  background: var(--danger);\n  color: white;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.file-badge.warning {\n  background: var(--warning);\n  color: white;\n}\n\n.file-badge.link-missing {\n  background: #ff8c42;\n  color: white;\n}\n\n/* Error tooltip on hover */\n.file-card-error-tooltip {\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  background: #2d2d2d;\n  color: white;\n  padding: 10px 14px;\n  border-radius: 10px;\n  font-size: 12px;\n  line-height: 1.4;\n  white-space: nowrap;\n  z-index: 100;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.2s ease;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);\n  pointer-events: none;\n}\n\n.file-card-error-tooltip::after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border: 6px solid transparent;\n  border-top-color: #2d2d2d;\n}\n\n.file-card:hover .file-card-error-tooltip {\n  opacity: 1;\n  visibility: visible;\n}\n\n.file-card-error-tooltip .error-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #ff8a80;\n}\n\n.file-card-error-tooltip .error-item + .error-item {\n  margin-top: 6px;\n}\n\n.file-card-error-tooltip .error-item svg {\n  width: 14px;\n  height: 14px;\n  flex-shrink: 0;\n}\n\n.file-card-error-tooltip .error-item span {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.file-card-error-tooltip .error-item.warning svg {\n  color: #ffb74d;\n}\n\n.file-card-preview {\n  position: relative;\n  aspect-ratio: 1;\n  background: #ffffff;\n  overflow: hidden;\n  border-radius: 12px 12px 0 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.file-card-preview img {\n  max-width: 100%;\n  max-height: 100%;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n}\n\n.file-card-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.file-card-placeholder svg {\n  width: 32px;\n  height: 32px;\n  opacity: 0.4;\n}\n\n.file-card-placeholder.image {\n  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);\n  color: #1976d2;\n}\n\n.file-card-placeholder.video {\n  background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);\n  color: #d32f2f;\n}\n\n.file-card-placeholder.html5 {\n  background: linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%);\n  color: #7b1fa2;\n}\n\n.file-card-type {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  width: 24px;\n  height: 24px;\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.95);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.file-card-type svg {\n  width: 14px;\n  height: 14px;\n  color: var(--text-secondary);\n}\n\n.file-card-remove {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 24px;\n  height: 24px;\n  border-radius: 6px;\n  border: none;\n  background: rgba(0, 0, 0, 0.6);\n  color: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: all 0.2s ease;\n}\n\n.file-card:hover .file-card-remove {\n  opacity: 1;\n}\n\n.file-card-remove:hover {\n  background: var(--danger);\n}\n\n.file-card-remove svg {\n  width: 14px;\n  height: 14px;\n}\n\n.file-card-info {\n  padding: 10px;\n}\n\n.file-card-name {\n  display: block;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 2px;\n}\n\n.file-card-meta {\n  font-size: 11px;\n  color: var(--text-tertiary);\n}\n\n.file-card-meta-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 2px;\n}\n\n.file-card-size {\n  font-size: 10px;\n  color: var(--text-tertiary);\n  white-space: nowrap;\n}\n\n.file-card-dimensions-input {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.file-card-dimensions-input span {\n  color: var(--text-tertiary);\n  font-size: 10px;\n}\n\n.file-card-dimensions-input .dim-input {\n  width: 32px;\n  padding: 2px 4px;\n  border: 1px solid transparent;\n  border-radius: 3px;\n  font-size: 10px;\n  text-align: center;\n  background: transparent;\n  -moz-appearance: textfield;\n  color: var(--text-secondary);\n}\n\n.file-card-dimensions-input .dim-input.filled {\n  color: var(--text-secondary);\n}\n\n.file-card-dimensions-input .dim-input:not(.filled) {\n  border-color: var(--danger);\n  color: var(--danger);\n  background: rgba(231, 76, 60, 0.05);\n}\n\n.file-card-dimensions-input .dim-input::-webkit-outer-spin-button,\n.file-card-dimensions-input .dim-input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.file-card-dimensions-input .dim-input:focus {\n  outline: none;\n  border-color: var(--accent-orange);\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n}\n\n.file-card-dimensions-input .dim-input::placeholder {\n  color: var(--text-tertiary);\n}\n\n\n/* Right Panel */\n.upload-right-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* Settings Card */\n.settings-card {\n  background: var(--bg-secondary);\n  border-radius: 16px;\n  padding: 24px;\n  animation: slideInRight 0.4s ease;\n}\n\n@keyframes slideInRight {\n  from {\n    opacity: 0;\n    transform: translateX(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.settings-header {\n  margin-bottom: 24px;\n}\n\n.settings-header h2 {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 4px;\n}\n\n.settings-header p {\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n/* Mode Toggle */\n.mode-toggle {\n  display: flex;\n  background: var(--bg-tertiary);\n  border-radius: 10px;\n  padding: 4px;\n  position: relative;\n  margin-bottom: 24px;\n}\n\n.mode-toggle-btn {\n  flex: 1;\n  padding: 10px 16px;\n  border: none;\n  background: transparent;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  position: relative;\n  z-index: 1;\n  transition: color 0.3s ease;\n}\n\n.mode-toggle-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.mode-toggle-btn.active {\n  color: var(--text-primary);\n}\n\n.mode-toggle-indicator {\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  width: calc(50% - 4px);\n  height: calc(100% - 8px);\n  background: var(--bg-secondary);\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.mode-toggle-indicator.individual {\n  transform: translateX(100%);\n}\n\n/* Settings Form */\n.settings-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-group label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.form-group label svg {\n  width: 16px;\n  height: 16px;\n  color: var(--text-tertiary);\n}\n\n.form-group input,\n.form-group textarea {\n  padding: 12px 14px;\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  font-size: 14px;\n  font-family: inherit;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  transition: all 0.2s ease;\n  resize: none;\n}\n\n.form-group input:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: var(--accent-orange);\n  box-shadow: 0 0 0 3px rgba(255, 107, 74, 0.1);\n}\n\n.form-group input::placeholder,\n.form-group textarea::placeholder {\n  color: var(--text-tertiary);\n}\n\n.settings-form .form-hint,\n.form-group .form-hint {\n  display: block;\n  font-size: 11px;\n  color: var(--text-tertiary);\n  margin-top: -2px;\n  padding: 0;\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n}\n\n/* Dimensions input row */\n.dimensions-warning {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 12px;\n  background: rgba(243, 156, 18, 0.1);\n  border-radius: 8px;\n  color: var(--warning);\n  font-size: 13px;\n  font-weight: 500;\n  margin-bottom: 12px;\n}\n\n.dimensions-warning svg {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n}\n\n.form-group-row {\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.form-group-small {\n  flex: 1;\n}\n\n.form-group-small input {\n  text-align: center;\n}\n\n.dimension-separator {\n  padding-bottom: 12px;\n  color: var(--text-tertiary);\n  font-size: 16px;\n}\n\n/* Apply Button */\n.btn-apply {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  padding: 14px;\n  border: none;\n  border-radius: 10px;\n  background: linear-gradient(135deg,\n    rgba(255, 107, 74, 0.1) 0%,\n    rgba(142, 58, 154, 0.1) 100%\n  );\n  color: var(--accent-orange);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-apply:hover {\n  background: linear-gradient(135deg,\n    rgba(255, 107, 74, 0.15) 0%,\n    rgba(142, 58, 154, 0.15) 100%\n  );\n}\n\n.btn-apply svg {\n  width: 18px;\n  height: 18px;\n}\n\n/* No Selection State */\n.no-selection {\n  text-align: center;\n  padding: 40px 20px;\n  color: var(--text-secondary);\n}\n\n.no-selection-icon {\n  width: 48px;\n  height: 48px;\n  margin: 0 auto 16px;\n  border-radius: 12px;\n  background: var(--bg-tertiary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.no-selection-icon svg {\n  width: 24px;\n  height: 24px;\n  color: var(--text-tertiary);\n}\n\n.no-selection p {\n  font-size: 14px;\n}\n\n/* Selected File Header */\n.selected-file-header {\n  display: flex;\n  gap: 12px;\n  padding: 12px;\n  background: var(--bg-tertiary);\n  border-radius: 10px;\n  margin-bottom: 8px;\n}\n\n.selected-file-preview {\n  width: 48px;\n  height: 48px;\n  border-radius: 8px;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.selected-file-preview img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.file-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.file-placeholder svg {\n  width: 20px;\n  height: 20px;\n  opacity: 0.5;\n}\n\n.file-placeholder.image {\n  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);\n  color: #1976d2;\n}\n\n.file-placeholder.video {\n  background: linear-gradient(135deg, #ffebee 0%, #ffcdd2 100%);\n  color: #d32f2f;\n}\n\n.file-placeholder.html5 {\n  background: linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%);\n  color: #7b1fa2;\n}\n\n.selected-file-info {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-width: 0;\n}\n\n.selected-file-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.selected-file-meta {\n  font-size: 12px;\n  color: var(--text-tertiary);\n}\n\n/* File Navigation */\n.file-navigation {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-top: 16px;\n  border-top: 1px solid var(--border-color);\n  margin-top: 8px;\n}\n\n.btn-nav {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  border: none;\n  background: transparent;\n  color: var(--text-secondary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n}\n\n.btn-nav:hover:not(:disabled) {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n}\n\n.btn-nav:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.btn-nav svg {\n  width: 16px;\n  height: 16px;\n}\n\n.file-counter {\n  font-size: 13px;\n  color: var(--text-tertiary);\n  font-weight: 500;\n}\n\n/* Summary Card */\n.summary-card {\n  background: var(--bg-secondary);\n  border-radius: 16px;\n  padding: 20px;\n  animation: slideInRight 0.4s ease 0.1s backwards;\n}\n\n.summary-card h3 {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 16px;\n}\n\n.summary-stats {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.summary-stat {\n  text-align: center;\n  padding: 12px;\n  background: var(--bg-tertiary);\n  border-radius: 10px;\n}\n\n.summary-stat .stat-value {\n  display: block;\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 2px;\n}\n\n.summary-stat .stat-label {\n  font-size: 11px;\n  color: var(--text-tertiary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.summary-types {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.summary-type {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.summary-type svg {\n  width: 14px;\n  height: 14px;\n}\n\n.summary-type.image {\n  background: rgba(14, 165, 233, 0.1);\n  color: #0369a1;\n}\n\n.summary-type.video {\n  background: rgba(239, 68, 68, 0.1);\n  color: #dc2626;\n}\n\n.summary-type.html5 {\n  background: rgba(139, 92, 246, 0.1);\n  color: #7c3aed;\n}\n\n/* ========================================\n   UPLOAD PROGRESS STATES\n   ======================================== */\n\n/* Upload progress bar in header */\n.upload-progress-bar {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  height: 3px;\n  background: var(--accent-gradient);\n  transition: width 0.3s ease;\n  border-radius: 0 2px 2px 0;\n}\n\n/* Upload button states */\n.btn-primary.uploading {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n  box-shadow: none;\n  pointer-events: none;\n  min-width: 180px;\n}\n\n.btn-primary.uploading .upload-btn-progress {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  background: var(--accent-gradient);\n  opacity: 0.2;\n  border-radius: 10px;\n  transition: width 0.3s ease;\n}\n\n.btn-primary.uploading .upload-btn-text {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Cancel button during upload */\n.btn-cancel {\n  padding: 12px 20px;\n  border: 1px solid var(--danger);\n  border-radius: 10px;\n  background: transparent;\n  color: var(--danger);\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-cancel:hover {\n  background: rgba(231, 76, 60, 0.1);\n}\n\n/* Spinner animation */\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.spinner {\n  width: 18px;\n  height: 18px;\n  border: 2px solid transparent;\n  border-top-color: currentColor;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n/* File card upload states */\n.file-card.uploading {\n  pointer-events: none;\n}\n\n.file-card.uploading .file-card-preview::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: rgba(255, 255, 255, 0.85);\n  z-index: 5;\n}\n\n.file-card-upload-overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  z-index: 6;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.2s ease;\n}\n\n.file-card.uploading .file-card-upload-overlay {\n  opacity: 1;\n  visibility: visible;\n}\n\n/* Circular progress indicator */\n.circular-progress {\n  width: 48px;\n  height: 48px;\n  position: relative;\n}\n\n.circular-progress svg {\n  transform: rotate(-90deg);\n  width: 48px;\n  height: 48px;\n}\n\n.circular-progress .progress-bg {\n  fill: none;\n  stroke: rgba(0, 0, 0, 0.1);\n  stroke-width: 4;\n}\n\n.circular-progress .progress-fill {\n  fill: none;\n  stroke: url(#progress-gradient);\n  stroke-width: 4;\n  stroke-linecap: round;\n  stroke-dasharray: 126;\n  stroke-dashoffset: 126;\n  transition: stroke-dashoffset 0.3s ease;\n}\n\n.circular-progress .progress-text {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n/* Success state */\n.file-card.upload-success {\n  box-shadow: 0 0 0 2px var(--success);\n}\n\n.file-card.upload-success:hover {\n  box-shadow: 0 0 0 2px var(--success), 0 8px 24px rgba(39, 174, 96, 0.2);\n}\n\n.file-badge.success {\n  background: var(--success);\n  color: white;\n}\n\n@keyframes checkmark-pop {\n  0% { transform: scale(0); }\n  50% { transform: scale(1.2); }\n  100% { transform: scale(1); }\n}\n\n.file-badge.success svg {\n  animation: checkmark-pop 0.3s ease;\n}\n\n/* Error state during upload */\n.file-card.upload-error {\n  box-shadow: 0 0 0 2px var(--danger);\n}\n\n@keyframes shake {\n  0%, 100% { transform: translateX(0); }\n  25% { transform: translateX(-4px); }\n  75% { transform: translateX(4px); }\n}\n\n.file-card.upload-error {\n  animation: shake 0.3s ease;\n}\n\n/* Upload complete summary */\n.upload-complete-banner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  background: linear-gradient(135deg, rgba(39, 174, 96, 0.1) 0%, rgba(39, 174, 96, 0.05) 100%);\n  border: 1px solid rgba(39, 174, 96, 0.2);\n  border-radius: 12px;\n  margin-bottom: 20px;\n}\n\n.upload-complete-banner.has-errors {\n  background: linear-gradient(135deg, rgba(243, 156, 18, 0.1) 0%, rgba(243, 156, 18, 0.05) 100%);\n  border-color: rgba(243, 156, 18, 0.2);\n}\n\n.upload-complete-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.upload-complete-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  background: var(--success);\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.upload-complete-icon svg {\n  width: 20px;\n  height: 20px;\n}\n\n.upload-complete-banner.has-errors .upload-complete-icon {\n  background: var(--warning);\n}\n\n.upload-complete-text h4 {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 2px;\n}\n\n.upload-complete-text p {\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n/* Responsive */\n@media (max-width: 1200px) {\n  .upload-content {\n    padding: 24px;\n  }\n\n  .upload-right-panel {\n    order: -1;\n  }\n}\n\n@media (max-width: 768px) {\n  .upload-header {\n    padding: 16px 24px;\n  }\n\n  .upload-header-content {\n    flex-direction: column;\n    gap: 16px;\n    align-items: flex-start;\n  }\n\n  .upload-content {\n    padding: 16px;\n  }\n\n  .drop-zone {\n    padding: 32px 24px;\n  }\n\n  .file-grid {\n    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n  }\n}\n\n/* ===== Edit Creatives Page Styles ===== */\n\n/* Edit mode drop zone - shows preview instead of drag-drop content */\n.drop-zone.edit-mode {\n  cursor: default;\n  padding: 24px;\n  min-height: 300px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.drop-zone.edit-mode:hover {\n  transform: none;\n}\n\n/* Preview wrapper inside edit mode drop zone */\n.edit-preview-wrapper {\n  width: 100%;\n  height: 100%;\n  min-height: 280px;\n  max-height: 480px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.edit-preview-wrapper .edit-preview-image {\n  max-width: 100%;\n  max-height: 480px;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n  border-radius: 8px;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);\n}\n\n.edit-preview-wrapper .edit-preview-video {\n  max-width: 100%;\n  max-height: 480px;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n  border-radius: 8px;\n  background: #000;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);\n}\n\n.edit-preview-wrapper .edit-preview-iframe {\n  border: none;\n  border-radius: 8px;\n  background: white;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);\n}\n\n/* Loading state */\n.loading-state {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid var(--border-color);\n  border-top-color: var(--accent-orange);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n/* File card meta row for edit page */\n.file-card-dims {\n  font-size: 11px;\n  color: var(--text-tertiary);\n}\n\n.file-card-id {\n  font-size: 10px;\n  color: var(--text-tertiary);\n  opacity: 0.7;\n}\n\n.file-card-meta-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Responsive adjustments for edit page */\n@media (max-width: 1200px) {\n  .edit-preview-container {\n    min-height: 250px;\n    max-height: 400px;\n  }\n\n  .edit-thumbnails-grid {\n    grid-template-columns: repeat(auto-fill, minmax(70px, 1fr));\n  }\n}\n\n@media (max-width: 768px) {\n  .edit-preview-container {\n    min-height: 200px;\n    padding: 16px;\n  }\n\n  .edit-preview-info {\n    padding: 12px 16px;\n  }\n\n  .edit-thumbnails-grid {\n    grid-template-columns: repeat(auto-fill, minmax(60px, 1fr));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
